import { render, staticRenderFns } from "./RequiredDocsTable.vue?vue&type=template&id=3194e979"
import script from "./RequiredDocsTable.vue?vue&type=script&lang=js"
export * from "./RequiredDocsTable.vue?vue&type=script&lang=js"
import style0 from "./RequiredDocsTable.vue?vue&type=style&index=0&id=3194e979&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports